import React, { useState } from 'react';
import Routes from '../../utils/routes';
import AppLink from '../app-link/appLink';
import Card from '../card/card';
import { Alert, AlertIcon, Box, Button, Flex, Icon, Input } from '@chakra-ui/react';
import { AiOutlineGoogle } from 'react-icons/ai';
import { SiMicrosoft } from 'react-icons/si';
import { BsMicrosoft } from 'react-icons/bs';
import { FcGoogle } from 'react-icons/fc';


type Props = {
  onLogin: (username: string, password: string) => void;
  onLoginUsingGoogle: () => void;
  onLoginUsingMicrosoft: () => void;
  disabled: boolean;
  loading: boolean;
  error?: string;
  success?: string;
};

export const LoginForm: React.FC<Props> = ({ onLogin, onLoginUsingGoogle, onLoginUsingMicrosoft, disabled, loading, error, success }) => {
  const [loadingState, setLoadingState] = useState({
    google: false,
    microsoft: false,
    login:false
  });

  const handleMicrosoftLogin = async () => {
    setLoadingState({ ...loadingState, microsoft: true });
    try {
      await onLoginUsingMicrosoft();
    } finally {
      //setLoadingState({ ...loadingState, microsoft: false });
    }
  };

  const handleGoogleLogin = async () => {
    setLoadingState({ ...loadingState, google: true });
    try {
      await onLoginUsingGoogle();
    } finally {
      //setLoadingState({ ...loadingState, google: false });
    }
  };
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = async (evt) => {
    evt.preventDefault();
  
    setLoadingState({ ...loadingState, login: true });
  
    try {
      await onLogin(email, password);
      // Handle invalid email or password scenario
      setLoadingState({ ...loadingState, login: false });
    } catch (error) {
      // Handle unexpected errors
      setLoadingState({ ...loadingState, login: false });
      console.error("Login failed:", error);
    }
  };
  
  return (
    <Flex minH="100vh" alignItems="center" justifyContent="center" py={12} px={4} backgroundColor="gray.200">
      <Flex maxW="container.xs" width="100%" flexDirection="column" gap={6}>
        <Box as="img" mx={'auto'} w={'auto'} maxHeight="64px" src="/logo.png" alt="StatusPing" />
        <Card>
          <Box mb={2}>
            <Box as="h2" fontSize="xl" textAlign="center" fontWeight="normal">
              Sign in with
            </Box>
          </Box>
          {error && (
            <Alert status="error">
              <AlertIcon />
              {error}
            </Alert>
          )}
          {success && (
            <Alert status="success">
              <AlertIcon />
              {success}
            </Alert>
          )}
          {/* <Button w="100%" size="lg" backgroundColor="#DB4437" colorScheme='red' color="white" onClick={handleGoogleLogin}
        isDisabled={disabled || loadingState.google}
        isLoading={loadingState.google}>
            <Icon as={AiOutlineGoogle} boxSize={6} mr={2} />
            Sign in using Google
          </Button><br/>
            <Button w="100%" size="lg" backgroundColor="#00A4EF" color="white" colorScheme='blue' onClick={handleMicrosoftLogin}
        isDisabled={disabled || loadingState.microsoft}
        isLoading={loadingState.microsoft}>
            <Icon as={SiMicrosoft} boxSize={6} mr={2} />
            Sign in using Microsoft
            </Button> */}

<Flex direction="row" p="4"  justifyContent="center" alignItems="center"   gap="6">
        <Button
          width="100%"
          bgGradient="linear(to-r, white, gray.50)"
          boxShadow="xl"
          _hover={{ borderColor: 'gray.400', boxShadow: '2xl', transform: 'scale(1.05)' }}
          transition="all 0.3s ease-in-out"
          colorScheme="gray.400"
          // loadingText="Google"
          onClick={handleGoogleLogin}
        isDisabled={disabled || loadingState.google}
        isLoading={loadingState.google}
          leftIcon={<Icon as={FcGoogle} w={8} h={8} />}
          size="lg"
          variant="outline"
          // border="2px"
        >
          Google
        </Button>
        <Button
          width="100%"
          bgGradient="linear(to-r, white, gray.50)"
          boxShadow="xl"
          _hover={{ borderColor: 'gray.400', boxShadow: '2xl', transform: 'scale(1.05)' }}
          transition="all 0.3s ease-in-out"
          colorScheme="gray.400"
          // loadingText="Microsoft"
          onClick={handleMicrosoftLogin}
        isDisabled={disabled || loadingState.microsoft}
        isLoading={loadingState.microsoft}
          leftIcon={<Icon as={BsMicrosoft} color="#2f2f9d" w={8} h={8} />}
          size="lg"
          variant="outline"
        >
          Microsoft
        </Button>
        </Flex>
          <Box textAlign="center" fontSize="lg" my={4}>
            {/* or using email and password */}
            Have an account with a different email?


          </Box>


          
          <Flex as="form" flexDirection="column" gap={6} onSubmit={handleSubmit}>
            <Flex flexDirection="column" gap={2} borderRadius="md" boxShadow={'sm'}>
              <div>
                <Input placeholder="Email address" type="email" onChange={(evt) => setEmail(evt.target.value)} value={email} />
              </div>
              <div>
                <Input placeholder="Password" type="password" onChange={(evt) => setPassword(evt.target.value)} value={password} />
              </div>
            </Flex>

            

            <div>
              <Button type="submit" size="lg" w="50%" colorScheme="blue" isDisabled={disabled} isLoading={loadingState.login}>
                Sign in
              </Button>
                  <AppLink to={Routes.FORGOT_PASSWORD} style={{ margin: '10px', float: 'right' }}>Forgot your password?</AppLink>
            </div>
          </Flex>
          <Box textAlign="center" mt={4}>
            {`Don't have an account? `}
            <AppLink to={Routes.SIGN_UP}>Sign up</AppLink>
          </Box>
        </Card>
      </Flex>
    </Flex>
  );
};

export default LoginForm;
